import React from "react";

import Navbar from "components/MI/Navbar";
import UserMenu from "components/layout/userMenuNew";

import {
  ButtonContainer,
  Container,
  Content,
  ContentImg,
  Img,
  Text,
  Title,
} from "./styles";

const UltragazEnergiaSucesso = (): JSX.Element => {
  return (
    <Navbar selected="ultragaz-energia-sucesso">
      <UserMenu />
      <Container>
        <Content>
          <ContentImg>
            <Img src="/static/banner_ultragaz-energia.png" />
          </ContentImg>
          <Title>Recebemos seus dados!</Title>
          <Text>
            Agora é só aguardar, em breve um especialista entrará em contato com
            você.
          </Text>
          <ButtonContainer to="/portal">
            Voltar para a tela inicial
          </ButtonContainer>
        </Content>
      </Container>
    </Navbar>
  );
};

export default UltragazEnergiaSucesso;
